import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=d2c8914e&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=d2c8914e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c8914e",
  null
  
)

export default component.exports